import { render, staticRenderFns } from "./ScrollerWidgetPreview.vue?vue&type=template&id=b5b25dc2"
import script from "./ScrollerWidgetPreview.vue?vue&type=script&lang=js"
export * from "./ScrollerWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports